// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__6sslo","Controls":"Game_Controls__UoLgk"};